import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { configureAmplify } from './config/amplify'
import './styles/main.css'

async function bootstrap() {
  await configureAmplify()
  const app = createApp(App)
  app.use(router)
  app.mount('#app')
}

bootstrap()
